import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import { Overview } from './1_Overview'
import { AboutGame } from './2_AboutGame'
import { BetPanel } from './3_BetPanel'
import { AnimalNumbers } from './4_AnimalNumbers'
import { Mode } from './4_Mode'
import { ExtraPanel } from './5_ExtraPanel'
import { SupportedLanguages } from './6_SupportedLanguages'
import { ComingSoon, ProductBanner, ProductDetails } from '../../../components'
import Content from '../../../components/ProductDetails/Content'
import { gameDetailsApi } from '../../../apis/strapiApi'
import { GameDetails, Game } from '../../../types'
import { useTranslation } from 'react-i18next'

const Details = () => {
  const [details, setDetails] = useState<GameDetails>()
  const [game, setGame] = useState<Game>()
  const { product, locale } = useParams()
  const { t } = useTranslation()

  //TODO: Use SWR to fetch articles
  useEffect(() => {
    if (product) {
      const getDetails = async () => {
        const data = await gameDetailsApi(product, locale)
        setGame(data?.data[0])
        setDetails(data?.data[0]?.attributes.detailsPage[0])
      }
      getDetails()
    }
  }, [locale, product])

  return (
    <Box>
      <Helmet>
        {game?.attributes && <title>{game.attributes.name} - iMoon B2B</title>}
      </Helmet>
      <ProductBanner
        images={{
          desktop: details?.banner?.bannerImg.data?.attributes?.url || '',
          mobile: details?.banner?.bannerImgMobile.data?.attributes?.url || '',
        }}
      />
      <ProductDetails>
        {!details?.releaseDate && (
          <Overview {...details?.overview} {...game?.attributes} />
        )}
        {details && (
          <>
            {details.aboutGame && (
              <Content
                title={t('products.details.about_game')}
                content={<AboutGame {...details?.aboutGame} />}
              />
            )}
            {details.betPanel && (
              <Content
                title={t('products.details.bet_panel')}
                content={<BetPanel {...details?.betPanel} />}
              />
            )}
            {details.gameMode && (
              <Content
                title={t('products.details.game_mode')}
                content={<Mode {...details?.gameMode} />}
              />
            )}
            {details.animalNumbers && (
              <Content
                title={t('products.details.animal_numbers')}
                content={<AnimalNumbers {...details?.animalNumbers} />}
              />
            )}
            {details.extraPanel && (
              <Content
                title={t('products.details.extra_panel')}
                content={<ExtraPanel list={details?.extraPanel} />}
              />
            )}
            {details.supportedLanguages && (
              <Content
                title={t('products.details.supported_languages')}
                content={
                  <SupportedLanguages {...details?.supportedLanguages} />
                }
              />
            )}
            {details.releaseDate && (
              <ComingSoon releaseDate={details.releaseDate} />
            )}
          </>
        )}
      </ProductDetails>
    </Box>
  )
}

export default Details
